jQuery(document).ready(function ($) {
    if (!$('.tabbed-content-block-component').length) {
        return;
    }

    console.log('Tabbed Content Block JS loaded');

    $('.tabbed-content-block-component .tab-button').on('click', function () {
        $(this).closest('li').siblings().find('.tab-button').removeClass('active');
        $(this).addClass('active');

        const tabIndex = $(this).parent().index();
        const tabContent = $(this).closest('.tabbed-content-block-component').find('.tab-content');

        // scroll into view
        $(this)[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        tabContent.removeClass('active');
        tabContent.eq(tabIndex).addClass('active');
    });
});